<!-- crm新能源 -->
<template>
  <Layout>
    <!-- banner -->
    <div class="banner">
      <div class="slider-area slider-style-2 variation-3 height-720 bg_image bg_image_fixed" :style="{
        'background-image': `url(${require(`@/assets/images/IndustrySolution/banner/industry-banner-crm-04.png`)})`,
      }">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-8 col-12 offset-lg-1">
              <div class="inner text-center">
                <h6 class="subtitle color-black mb--15" data-aos="fade-up" data-aos-delay="200">
                  {{ $t("solution_crm.new-energy.header.title01") }}
                </h6>
                <img data-aos="fade-up" data-aos-delay="250" class="icon2 mb--25" :src="require('@/assets/images/IndustrySolution/banner/industry-banner-crm-icon1.png')
                  " alt="" />
                <p class="col-12 col-lg-11 description color-black" data-aos="fade-up" data-aos-delay="300">
                  {{ $t("solution_crm.new-energy.header.description") }}
                </p>
              </div>
            </div>
            <div class="row col-lg-3 col-md-4 col-sm-12 col-12 text-center">
              <div class="col-6 col-lg-12 col-md-12 col-sm-6 p-3 p-lg-4 p-md-4">
                <div class="text_tab text_tab_padding ptb-8">
                  {{ $t("solution_crm.new-energy.header.title1") }}
                </div>
              </div>
              <div class="col-6 col-lg-12 col-md-12 col-sm-6 p-3 p-lg-4 p-md-4">
                <div class="text_tab text_tab_padding ptb-8">
                  {{ $t("solution_crm.new-energy.header.title2") }}
                </div>
              </div>
              <div class="col-6 col-lg-12 col-md-12 col-sm-6 p-3 p-lg-4 p-md-4">
                <div class="text_tab text_tab_padding ptb-8">
                  {{ $t("solution_crm.new-energy.header.title3") }}
                </div>
              </div>
              <div class="col-6 col-lg-12 col-md-12 col-sm-6 p-3 p-lg-4 p-md-4">
                <div class="text_tab text_tab_padding ptb-8">
                  {{ $t("solution_crm.new-energy.header.title4") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rn-section-gapBottom industry-banner">
        <div class="container">
          <div class="row">
            <div class="col-lg-10 offset-lg-1">
              <div class="row row--0 align-items-center mt_dec--30 wrapper">
                <div class="col-lg-12 mt_sm--30 mb_sm--30">
                  <div class="content row align-items-center">
                    <div class="col-12 col-lg-2 col-md-2 text-center">
                      <img class="icon" :src="require('@/assets/images/IndustrySolution/banner/industry-banner-icon1.png')
                        " alt="" />
                    </div>
                    <div class="inner col-12 col-lg-10 col-md-10">
                      <h4 class="title mb--10">
                        {{ $t("solution_crm.new-energy.header.card.title") }}
                      </h4>
                      <p class="description mb--0">
                        {{ $t("solution_crm.new-energy.header.card.description1") }}
                        <br />
                        {{ $t("solution_crm.new-energy.header.card.description2") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <section class="rn-section-gap">
      <SectionTitle :title="$t('solution.solutions_title')" description="SOLUTIONS" textAlign="center" />
      <div class="container">
        <crmNewEnergySolution></crmNewEnergySolution>
      </div>
    </section>
    <!-- 客户价值 -->
    <value :valueStyle="3" :list="valueList"></value>
    <!-- 方案优势 -->
    <advantage :advantageStyle="2" :list="advantageList"></advantage>
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
import Advantage from '../components/crmComponents/Advantage.vue'
import Value from '../components/crmComponents/Value.vue';
import crmNewEnergySolution from '../components/crmComponents/newEnergySolution.vue';
import ClassicCases from '../components/ClassicCases.vue';
export default {
  name: "NewEnergy",
  components: { Layout, SectionTitle, Advantage, Value, crmNewEnergySolution, ClassicCases },
  data() {
    return {
      valueList: [
        {
          title: this.$t("solution_crm.new-energy.values.tab.tab01.title"),
          desc: [
            { title: this.$t("solution_crm.new-energy.values.tab.tab01.desc1") },
            { title: this.$t("solution_crm.new-energy.values.tab.tab01.desc2") },
            { title: this.$t("solution_crm.new-energy.values.tab.tab01.desc3") }
          ]
        },
        { title: this.$t("solution_crm.new-energy.values.tab.tab02.title"), desc: this.$t("solution_crm.new-energy.values.tab.tab02.desc") },
        { title: this.$t("solution_crm.new-energy.values.tab.tab03.title"), desc: this.$t("solution_crm.new-energy.values.tab.tab03.desc") },
      ],
      advantageList: [
        {
          desc: this.$t("solution_crm.new-energy.advantages.tab.tab01.desc"),
          img: require('@/assets/images/IndustrySolution/crm/newEnergy/advantage_01.png')
        },
        {
          desc: this.$t("solution_crm.new-energy.advantages.tab.tab02.desc"),
          img: require('@/assets/images/IndustrySolution/crm/newEnergy/advantage_02.png')
        },
        {
          desc: this.$t("solution_crm.new-energy.advantages.tab.tab03.desc"),
          img: require('@/assets/images/IndustrySolution/crm/newEnergy/advantage_03.png')
        }
      ],
      ClassicCasesData: [
        {
          // imageBackground: require('@/assets/images/IndustrySolution/ClassicCases/360_background.png'),
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/TAIDA.jpg'),
        },
        {
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/SUNGROW.png'),
        },
        {
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/CHNT.png'),
        },
        {
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/Trinasolar.png'),
        },
        {
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/VERTIV.png'),
        },
      ]
    };
  },

}

</script>
